import { ClientProtocolEnum } from './enums';

export const ClientProtocolDatasource = [
    {
        id: ClientProtocolEnum.AUTHORIZATION_CODE,
        ten: 'Authorization code'
    },
    {
        id: ClientProtocolEnum.HYBRID,
        ten: 'Web Application - Hybrid'
    },
    {
        id: ClientProtocolEnum.IMPLICIT,
        ten: 'Web Application - Implicit'
    },
    {
        id: ClientProtocolEnum.CLIENT_CREDENTIAL,
        ten: 'Machine / Service / Robot - Client credentials'
    },
    {
        id: ClientProtocolEnum.RESOURCE_OWNER_PASSWORD,
        ten: 'Web Application - Password flow'
    },
    {
        id: ClientProtocolEnum.DEVICE_FLOW,
        ten: 'Mobile - Device flow'
    },
];


export class ClientGrantType {
    public clientId: number;
    public grantType: string;
    public id: number;
}


export class ClientCorsOrigin {
    public clientId: number;
    public origin: string;
    public id: number;
}

export class ClientClaim {
    public clientId: number;
    public id: number;
    public type: string;
    public value: string;
}
